import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class JobRequiredSkillValidationUtils {

    static requiredSkillsValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {

            if (!control.value || !Array.isArray(control.value)) {
                return { required: true };
            }

            const skills = control.value.map((skill: string) => skill.trim()).filter((skill: string) => skill);

            if (skills.length === 0) {
                return { required: true };
            }

            if (skills.length > 20) {
                return { maxSkills: true };
            }

            const normalizedSkills = skills.map((s: string) => s.toLowerCase());
            const uniqueSkills = new Set(normalizedSkills);

            if (uniqueSkills.size !== normalizedSkills.length) {
                return { duplicateSkills: true };
            }

            const regex = /^[A-Za-z0-9+#.\-\s&()_\/,]+$/;

            const invalidSkill = skills.some((skill: string) => !regex.test(skill));

            if (invalidSkill) {
                return { invalidSkillFormat: true };
            }
            return null;
        };
    }

    static getRequiredSkillsError(control: AbstractControl | null): string {

        if (!control || !control.errors || !control.touched) {
            return '';
        }

        if (control.errors['required']) {
            return 'Skills is required.';
        }

        if (control.errors['duplicateSkills']) {
            return 'Duplicate skills are not allowed.';
        }

        if (control.errors['maxSkills']) {
            return 'Maximum 20 skills allowed.';
        }

        if (control.errors['invalidSkillFormat']) {
            return 'Invalid skill format detected.';
        }
        return '';
    }

}